import * as Yup from 'yup';
import { phoneNumberValidation } from '../../yupValidations';

export const adminAddDepartmentSchema = Yup.object().shape({
    userId: Yup.string().required("Required"),
    contactPerson: Yup.string().required("Required"),
    departmentType: Yup.string().required("Required"),
    email: Yup.string().email().required("Required"),
    phoneNumber: phoneNumberValidation(),
});